import { TheActivityToast } from '../components/activity-toast';
import { NavMobile } from '../components/nav-mobile';
import { TheTicker } from '../components/ticker';
import { TheMarketFooter } from './footer';
import { TheMarketHeader } from './header';
import { ConnectWalletBridge } from '@/client/components/connect-wallet-bridge';
import { ScrollTop } from '@/client/layouts/components/scroll-top';
import { PropsWithChildren } from 'react';

export type TheMarketLayoutProps = PropsWithChildren;

export const TheMarketLayout = ({ children }: TheMarketLayoutProps) => {
  return (
    <>
      <TheMarketHeader />
      <TheTicker />
      <ConnectWalletBridge />
      <main className="w-full max-w-screen-3xl mx-auto">{children}</main>
      <NavMobile />
      <TheActivityToast />
      <ScrollTop />
      <TheMarketFooter />
    </>
  );
};

export default TheMarketLayout;
